// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"0ddbd5bf","787":"618e7926"}[chunkId] + ".chunk.js";
};